export default [
  {
    path: "employees",
    name: "rrhh-employees",
    redirect: { name: "rrhh-employees-list" },
    component: () => import("@/views/rrhh/views/employees/Employees.vue"),
    meta: {
      section: 8,
      breadcrumb: [
        {
          text: "Employees",
          active: true,
        },
      ],

      tabs: [
        {
          title: "Employees",
          name: "rrhh-employees-list",
        },
        // {
        //   title: "Departament",
        //   name: "rrhh-employees-departament",
        // },
      ],
    },

    children: [
      {
        path: "employees",
        name: "rrhh-employees-list",
        component: () =>
          import("@/views/rrhh/views/employees/components/EmployeeTable.vue"),
        meta: {
          section: 8,
          pageTitle: "Employees",
          breadcrumb: [
            {
              text: "Employees",
            },
          ],
          tab: 1,
        },
      },
      // {
      //   path: "department",
      //   name: "rrhh-employees-departament",
      //   component: () => import("@/views/rrhh/views/employees/components/EmployeesByDepartament.vue"),
      //   meta: {
      //     section: 8,
      //     pageTitle: "Department",
      //     breadcrumb: [
      //       {
      //         text: "Department",
      //       },
      //       {
      //         text: "Active",
      //         active: true,
      //       },
      //     ],
      //     tab: 2,
      //   },
      // },
    ],
  },
  {
    path: 'information/:id',
    component: () => import(/* webpackChunkName: "RrhhEmployeesInfoMain" */ '@/views/rrhh/views/employees/components/information/InformationEmployee.vue'),
    name: 'rrhh-employees-information',
    redirect: { name: "rrhh-employees-dash-basic-information" },
    meta: {
      section: 8,
    },
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "RrhhEmployeesInformation" */ '@/views/rrhh/views/employees/components/information/basic-information/BasicInformation.vue'),
        name: 'rrhh-employees-dash-basic-information',
        meta: {
          section: 8,
          pageTitle: "Employees",
          breadcrumb: [{
            text: 'Basic Information',
            active: true,
          }],
          basicInformationRoute: 'rrhh-employees-dash-basic-information',
          jobDetailsRoute: 'rrhh-employees-dash-job-detail',
          scheduleRoute: 'rrhh-employees-dash-schedule',
          filesRoute: 'rrhh-employees-dash-files',
          employeesRoute: 'employees-rrhh',
          employeeRoute: 'information-employee-rrhh',
          listEmployeesRoute: 'rrhh-employees-list',
          listDepartmentRoute: 'list-department-rrhh',
          vacacionesRoute: 'rrhh-employees-vacaciones',
        },
      },
      {
        path: 'files',
        component: () => import(/* webpackChunkName: "RrhhEmployeesFiles" */ '@/views/rrhh/views/employees/components/information/files/Files.vue'),
        name: 'rrhh-employees-dash-files',
        meta: {
          section: 8,
          pageTitle: "Employees",
          breadcrumb: [{
            text: 'Files',
            active: true,
          }],
          basicInformationRoute: 'rrhh-employees-dash-basic-information',
          jobDetailsRoute: 'rrhh-employees-dash-job-detail',
          scheduleRoute: 'rrhh-employees-dash-schedule',
          filesRoute: 'rrhh-employees-dash-files',
          employeesRoute: 'employees-rrhh',
          employeeRoute: 'information-employee-rrhh',
          listEmployeesRoute: 'rrhh-employees-list',
          listDepartmentRoute: 'list-department-rrhh',
          vacacionesRoute: 'rrhh-employees-vacaciones',
        },
      },
      {
        path: 'job',
        component: () => import(/* webpackChunkName: "RrhhEmployeesJobDetails" */ '@/views/rrhh/views/employees/components/information/job-details/JobDetails.vue'),
        name: 'rrhh-employees-dash-job-detail',
        meta: {
          section: 8,
          pageTitle: "Employees",
          breadcrumb: [{
            text: 'Information',
            active: true,
          }],
          basicInformationRoute: 'rrhh-employees-dash-basic-information',
          jobDetailsRoute: 'rrhh-employees-dash-job-detail',
          scheduleRoute: 'rrhh-employees-dash-schedule',
          filesRoute: 'rrhh-employees-dash-files',
          employeesRoute: 'employees-rrhh',
          employeeRoute: 'information-employee-rrhh',
          listEmployeesRoute: 'rrhh-employees-list',
          listDepartmentRoute: 'list-department-rrhh',
          vacacionesRoute: 'rrhh-employees-vacaciones',
        },
      },
      {
        path: 'schedule',
        component: () => import(/* webpackChunkName: "RrhhScheduleEmployee" */ '@/views/rrhh/views/employees/components/information/schedule/Schedule.vue'),
        name: 'rrhh-employees-dash-schedule',
        meta: {
          section: 8,
          pageTitle: "Employees",
          breadcrumb: [{
            text: 'Schedule',
            active: true,
          }],
          basicInformationRoute: 'rrhh-employees-dash-basic-information',
          jobDetailsRoute: 'rrhh-employees-dash-job-detail',
          scheduleRoute: 'rrhh-employees-dash-schedule',
          filesRoute: 'rrhh-employees-dash-files',
          employeesRoute: 'employees-rrhh',
          employeeRoute: 'information-employee-rrhh',
          listEmployeesRoute: 'rrhh-employees-list',
          listDepartmentRoute: 'list-department-rrhh',
          vacacionesRoute: 'rrhh-employees-vacaciones',
        },
      },
      {
        path: 'vacaciones',
        component: () => import(/* webpackChunkName: "RrhhVacacionesEmployee" */ '@/views/rrhh/views/employees/components/information/vacaciones/Vacaciones.vue'),
        name: 'rrhh-employees-vacaciones',
        meta: {
          section: 8,
          pageTitle: "Employees",
          breadcrumb: [{
            text: 'Vacaciones',
            active: true,
          }],
          basicInformationRoute: 'rrhh-employees-dash-basic-information',
          jobDetailsRoute: 'rrhh-employees-dash-job-detail',
          scheduleRoute: 'rrhh-employees-dash-schedule',
          filesRoute: 'rrhh-employees-dash-files',
          employeesRoute: 'employees-rrhh',
          employeeRoute: 'information-employee-rrhh',
          listEmployeesRoute: 'rrhh-employees-list',
          listDepartmentRoute: 'list-department-rrhh',
          vacacionesRoute: 'rrhh-employees-vacaciones',
        },
      },
    ],
  },
];
